import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const lightTheme: OctopusTheme = {
    "colorInterfaceBorderPrimary": globals["colorScales"]["navy"]["200"],
    "colorInterfaceBorderSecondary": globals["colorScales"]["navy"]["100"],
    "colorInterfaceBorderTertiary": globals["colorScales"]["navy"]["300"],
    "colorInterfaceBorderLink": globals["colorScales"]["blue"]["500"],
    "colorInterfaceBackgroundPrimary": globals["colorScales"]["white"],
    "colorInterfaceBackgroundSecondary": globals["colorScales"]["navy"]["100"],
    "colorInterfaceBackgroundSubtle": globals["colorScales"]["navy"]["200"],
    "colorInterfaceBackgroundLink": globals["colorScales"]["blue"]["500"],
    "colorInterfaceIconPrimary": globals["colorScales"]["navy"]["700"],
    "colorInterfaceIconSecondary": globals["colorScales"]["navy"]["600"],
    "colorInterfaceIconSubtle": globals["colorScales"]["navy"]["500"],
    "colorInterfaceIconDisabled": globals["colorScales"]["navy"]["400"],
    "colorInterfaceIconLink": globals["colorScales"]["blue"]["500"],
    "colorInterfaceTextPrimary": globals["colorScales"]["navy"]["700"],
    "colorInterfaceTextSecondary": globals["colorScales"]["navy"]["600"],
    "colorInterfaceTextSubtle": globals["colorScales"]["navy"]["500"],
    "colorInterfaceTextDisabled": globals["colorScales"]["navy"]["400"],
    "colorInterfaceTextLink": globals["colorScales"]["blue"]["500"],
    "colorTableCellTextPrimary": globals["colorScales"]["navy"]["700"],
    "colorTableCellTextSubtle": globals["colorScales"]["navy"]["600"],
    "colorTableCellTextDisabled": globals["colorScales"]["navy"]["300"],
    "colorTableCellTextLink": globals["colorScales"]["blue"]["500"],
    "colorTableCellBorderPrimary": globals["colorScales"]["navy"]["200"],
    "colorTableCellBorderSecondary": globals["colorScales"]["navy"]["100"],
    "colorTableCellBackgroundDefault": globals["colorScales"]["white"],
    "colorTableCellBackgroundHover": globals["colorScales"]["navy"]["100"],
    "colorTableCellIconPrimary": globals["colorScales"]["navy"]["700"],
    "colorTableSortTextPrimary": globals["colorScales"]["navy"]["700"],
    "colorTableSortTextSubtle": globals["colorScales"]["navy"]["600"],
    "colorTableSortTextDisabled": globals["colorScales"]["navy"]["300"],
    "colorTableSortTextLink": globals["colorScales"]["blue"]["500"],
    "colorTableSortBorderPrimary": globals["colorScales"]["navy"]["200"],
    "colorTableSortBorderSecondary": globals["colorScales"]["navy"]["100"],
    "colorTableSortBackgroundDefault": globals["colorScales"]["white"],
    "colorTableSortBackgroundHover": globals["colorScales"]["navy"]["100"],
    "colorTableSortIconPrimary": globals["colorScales"]["navy"]["700"],
    "colorAlertTextInfo": globals["colorScales"]["blue"]["600"],
    "colorAlertTextSuccess": globals["colorScales"]["green"]["600"],
    "colorAlertTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorAlertTextDanger": globals["colorScales"]["red"]["600"],
    "colorAlertTextBody": globals["colorScales"]["black"],
    "colorAlertIconInfo": globals["colorScales"]["blue"]["600"],
    "colorAlertIconSuccess": globals["colorScales"]["green"]["600"],
    "colorAlertIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorAlertIconDanger": globals["colorScales"]["red"]["600"],
    "colorAlertIconDismiss": globals["colorScales"]["navy"]["700"],
    "colorAlertBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorAlertBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorAlertBorderWarning": globals["colorScales"]["yellow"]["500"],
    "colorAlertBorderDanger": globals["colorScales"]["red"]["500"],
    "colorAlertBackgroundInfo": globals["colorScales"]["blue"]["100"],
    "colorAlertBackgroundSuccess": globals["colorScales"]["green"]["100"],
    "colorAlertBackgroundWarning": globals["colorScales"]["yellow"]["100"],
    "colorAlertBackgroundDanger": globals["colorScales"]["red"]["100"],
    "colorMenuListTextPrimary": globals["colorScales"]["navy"]["700"],
    "colorMenuListTextSecondary": globals["colorScales"]["navy"]["600"],
    "colorMenuListTextHighlight": globals["colorScales"]["blue"]["500"],
    "colorMenuListBackgroundDefault": globals["colorScales"]["white"],
    "colorMenuListBackgroundHover": globals["colorScales"]["navy"]["100"],
    "colorMenuListIconPrimary": globals["colorScales"]["navy"]["500"],
    "colorTextFieldTextDefault": globals["colorScales"]["navy"]["500"],
    "colorTextFieldTextHover": globals["colorScales"]["navy"]["500"],
    "colorTextFieldTextActive": globals["colorScales"]["navy"]["700"],
    "colorTextFieldTextSmallTextDefault": globals["colorScales"]["navy"]["700"],
    "colorTextFieldTextSmallTextActive": globals["colorScales"]["blue"]["500"],
    "colorTextFieldTextSmallTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldTextLabelDefault": globals["colorScales"]["navy"]["700"],
    "colorTextFieldTextLabelActive": globals["colorScales"]["blue"]["500"],
    "colorTextFieldTextLabelDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldBorderDefault": globals["colorScales"]["navy"]["300"],
    "colorTextFieldBorderHover": globals["colorScales"]["navy"]["500"],
    "colorTextFieldBorderActive": globals["colorScales"]["blue"]["500"],
    "colorTextFieldBorderDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldIconDefault": globals["colorScales"]["navy"]["700"],
    "colorChipFilledTextPrimary": globals["colorScales"]["navy"]["600"],
    "colorChipFilledTextSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledTextInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledTextSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipFilledTextDanger": globals["colorScales"]["red"]["600"],
    "colorChipFilledBackgroundPrimary": globals["colorScales"]["navy"]["200"],
    "colorChipFilledBackgroundSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledBackgroundInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledBackgroundSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledBackgroundWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipFilledBackgroundDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledIconPrimary": globals["colorScales"]["navy"]["600"],
    "colorChipFilledIconSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledIconInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledIconSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipFilledIconDanger": globals["colorScales"]["red"]["600"],
    "colorChipOutlinedBorderPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedBorderSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedBorderWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedBorderDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedTextPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedTextSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedTextInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedTextSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedTextWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedTextDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedIconPrimary": globals["colorScales"]["navy"]["500"],
    "colorChipOutlinedIconSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedIconInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedIconSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedIconWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedIconDanger": globals["colorScales"]["red"]["500"],
    "colorBackgroundPrimary": globals["colorScales"]["white"],
    "colorBackgroundSecondary": globals["colorScales"]["navy"]["100"],
    "colorButtonBackgroundPrimaryHover": "rgba(26, 119, 202, 0.16)",
    "colorButtonBackgroundPrimaryPressed": "rgba(26, 119, 202, 0.32)",
    "colorButtonBackgroundPrimaryDisabled": globals["colorScales"]["navy"]["200"],
    "colorButtonBackgroundSecondaryHover": "rgba(0, 135, 77, 0.16)",
    "colorButtonBackgroundSecondaryPressed": "rgba(0, 135, 77, 0.32)",
    "colorButtonBackgroundSecondaryDisabled": globals["colorScales"]["navy"]["200"],
    "colorButtonBackgroundSubtleHover": "rgba(85, 121, 153, 0.16)",
    "colorButtonBackgroundSubtlePressed": "rgba(85, 121, 153, 0.32)",
    "colorButtonBackgroundSubtleDisabled": globals["colorScales"]["navy"]["200"],
    "colorButtonBackgroundDangerDefault": globals["colorScales"]["red"]["500"],
    "colorButtonBackgroundDangerHover": globals["colorScales"]["red"]["600"],
    "colorButtonBackgroundDangerPressed": globals["colorScales"]["red"]["700"],
    "colorButtonBackgroundDangerDisabled": globals["colorScales"]["navy"]["200"],
    "colorButtonIconPrimaryDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonIconPrimaryDisabled": globals["colorScales"]["white"],
    "colorButtonIconSecondaryDefault": globals["colorScales"]["green"]["500"],
    "colorButtonIconSecondaryDisabled": globals["colorScales"]["white"],
    "colorButtonIconSubtleDefault": globals["colorScales"]["navy"]["500"],
    "colorButtonIconSubtleDisabled": globals["colorScales"]["white"],
    "colorButtonIconDangerDefault": globals["colorScales"]["white"],
    "colorButtonIconDangerDisabled": globals["colorScales"]["white"],
    "colorButtonIconLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonIconLinkHover": globals["colorScales"]["blue"]["600"],
    "colorButtonIconLinkDisabled": globals["colorScales"]["navy"]["300"],
    "colorButtonTextPrimaryDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonTextPrimaryDisabled": globals["colorScales"]["white"],
    "colorButtonTextSecondaryDefault": globals["colorScales"]["green"]["500"],
    "colorButtonTextSecondaryDisabled": globals["colorScales"]["white"],
    "colorButtonTextSubtleDefault": globals["colorScales"]["navy"]["500"],
    "colorButtonTextSubtleDisabled": globals["colorScales"]["white"],
    "colorButtonTextDangerDefault": globals["colorScales"]["white"],
    "colorButtonTextDangerDisabled": globals["colorScales"]["white"],
    "colorButtonTextLinkDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonTextLinkHover": globals["colorScales"]["blue"]["600"],
    "colorButtonTextLinkDisabled": globals["colorScales"]["navy"]["300"],
    "colorButtonBorderPrimaryDefault": globals["colorScales"]["blue"]["400"],
    "colorButtonBorderPrimaryDisabled": globals["colorScales"]["navy"]["200"],
    "colorButtonBorderSecondaryDefault": globals["colorScales"]["green"]["400"],
    "colorButtonBorderSecondaryDisabled": globals["colorScales"]["navy"]["200"],
    "colorButtonBorderSubtleDefault": globals["colorScales"]["navy"]["400"],
    "colorButtonBorderSubtleDisabled": globals["colorScales"]["navy"]["200"],
    "colorModalBackgroundPrimary": globals["colorScales"]["white"],
    "colorModalOverlay": "rgba(17, 26, 35, 0.56)",
    "colorProgressBarForegroundLinear": globals["colorScales"]["blue"]["500"],
    "colorProgressBarForegroundCircular": globals["colorScales"]["blue"]["500"],
    "colorProgressBarBackgroundLinear": globals["colorScales"]["blue"]["200"],
    "colorProgressBarTextPrimary": globals["colorScales"]["navy"]["700"],
    "colorNavigationButtonBackgroundPrimaryDefault": globals["colorScales"]["navy"]["800"],
    "colorNavigationButtonBackgroundPrimaryHover": globals["colorScales"]["blue"]["500"],
    "colorNavigationButtonBackgroundPrimaryPressed": globals["colorScales"]["blue"]["500"],
    "colorNavigationButtonTextPrimary": globals["colorScales"]["white"],
    "colorNavigationButtonIconPrimary": globals["colorScales"]["white"],
    "colorNavigationBackgroundPrimary": globals["colorScales"]["navy"]["900"],
    "colorNavigationBackgroundSecondary": globals["colorScales"]["navy"]["100"],
    "colorNavigationLinkBackgroundPrimaryHover": globals["colorScales"]["blue"]["500"],
    "colorNavigationLinkBackgroundPrimaryPressed": globals["colorScales"]["blue"]["600"],
    "colorNavigationLinkBackgroundPrimaryActive": globals["colorScales"]["blue"]["500"],
    "colorNavigationLinkTextPrimary": globals["colorScales"]["white"],
    "colorNavigationLinkIconPrimary": globals["colorScales"]["white"],
    "colorPaginationBackgroundDefault": globals["colorScales"]["white"],
    "colorPaginationBackgroundHover": globals["colorScales"]["navy"]["400"],
    "colorPaginationBackgroundActive": globals["colorScales"]["blue"]["500"],
    "colorPaginationBackgroundDisabled": globals["colorScales"]["white"],
    "colorPaginationTextDefault": globals["colorScales"]["navy"]["700"],
    "colorPaginationTextHover": globals["colorScales"]["white"],
    "colorPaginationTextActive": globals["colorScales"]["white"],
    "colorPaginationTextDisabled": globals["colorScales"]["navy"]["400"],
    "colorPaginationIconDefault": globals["colorScales"]["navy"]["700"],
    "colorPaginationIconHover": globals["colorScales"]["white"],
    "colorPaginationIconActive": globals["colorScales"]["white"],
    "colorPaginationIconDisabled": globals["colorScales"]["navy"]["400"],
    "colorMockMenuHover": globals["colorScales"]["grey"]["200"],
    "colorMockMenuTernaryText": globals["colorScales"]["grey"]["600"],
    "colorMockMenuPrimary": globals["colorScales"]["blue"]["500"],
    "colorMockMenuLinkText": globals["colorScales"]["blue"]["500"],
    "shadowExtraSmall": "0 1px 8px 0 rgba(0,0,0,0.02), 0 1px 2px 0 rgba(0,0,0,0.06)",
    "shadowSmall": "0 1px 1px 0 rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.06)",
    "shadowMedium": "0 6px 12px 0 rgba(0,0,0,0.10), 0 1px 4px 0 rgba(0,0,0,0.04)",
    "shadowLarge": "0 14px 32px -4px rgba(0,0,0,0.12), 0 2px 6px 0 rgba(0,0,0,0.10)",
    "shadowFocusDefault": "0 0 0 3px #90CEFF"
};
